export const appsAppGroupIdChartsAttributeNames = "/apps/:app_group_id/charts/attribute_names";
